export enum AutoExportFormatterConfigurationIseMeteringIdentificationType {
    MeteringCode,
    DeviceLocationId,
    InternalNo,
    FactoryNo,
}
